import {
  Button,
  Form,
  Input,
  Modal,
  Select,
  Space,
} from '@arco-design/web-react';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { TradingProduct } from '../../service/trading';
import { convertToURL } from '../../common/utils';
import { useEffect } from 'react';

const initialValues = {
  title: 'Product Catalog',
  email: 'sandy@hihonour.com',
  companyName: 'IFans HomeTextiles Company',
  location: 'Jujin Road, Xiangchen District, Suzhou',
};

type Props = {
  visible: boolean;
  onCancel: () => void;
  selectedProducts: TradingProduct[];
  formValues?: any;
};

const generateOptions = (selectedProducts: TradingProduct[]) =>
  selectedProducts.map((product) => {
    const rawUrl = product.img_url;
    const img_url = rawUrl?.startsWith('http')
      ? rawUrl
      : convertToURL(rawUrl || '');
    return {
      label: (
        <Space style={{ padding: '8px 0px' }}>
          <img
            src={img_url}
            style={{ objectFit: 'contain', width: '50px', height: '50px' }}
            alt="product"
          ></img>
          <span>{product.item_number || product.product_name}</span>
        </Space>
      ),
      value: img_url,
    };
  });

const getDescByImageUrl = (
  selectedProducts: TradingProduct[],
  imageUrl?: string
) => {
  const p = selectedProducts.find((product) =>
    imageUrl?.includes(product.img_url)
  );
  return p?.descriptions;
};

const getTitleByImageUrl = (
  selectedProducts: TradingProduct[],
  imageUrl?: string
) => {
  const p = selectedProducts.find((product) =>
    imageUrl?.includes(product.img_url)
  );
  return p?.product_name;
};

const getSizeByImageUrl = (
  selectedProducts: TradingProduct[],
  imageUrl?: string
) => {
  const p = selectedProducts.find((product) =>
    imageUrl?.includes(product.img_url)
  );
  return p?.product_size;
};

const getItemNumberByImageUrl = (
  selectedProducts: TradingProduct[],
  imageUrl?: string
) => {
  const p = selectedProducts.find((product) =>
    imageUrl?.includes(product.img_url)
  );
  return p?.item_number;
};

const getUuidByImageUrl = (
  selectedProducts: TradingProduct[],
  imageUrl?: string
) => {
  const p = selectedProducts.find((product) =>
    imageUrl?.includes(product.img_url)
  );
  return p?.uuid;
};

const Index = ({ visible, onCancel, selectedProducts, formValues }: Props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (formValues) {
      form.setFieldsValue(formValues);
    }
  }, [formValues, form]);

  return (
    <Modal
      visible={visible}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      onOk={() => {
        form.submit();
      }}
      title="编辑商品目录"
      style={{ width: 800 }}
    >
      <Form
        form={form}
        onSubmit={(values) => {
          const { selected_products, ...rest } = values;
          const products = (selected_products || []).map((p: any) => ({
            uuid: getUuidByImageUrl(selectedProducts, p.image_url),
            img_url: p.image_url,
            product_json: JSON.stringify(p),
          }));
          rest.selected_products = products;
          localStorage.setItem('CATALOG.KEY', JSON.stringify(rest));
          window.open('/preview', '_blank');
        }}
        initialValues={initialValues}
      >
        <Form.Item
          field="client"
          label="客户"
          rules={[{ required: true, message: '客户为必填项' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          field="title"
          label="标题"
          rules={[{ required: true, message: '标题为必填项' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          field="keyword"
          label="产品种类"
          rules={[{ required: true, message: '产品种类为必填项' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          field="email"
          label="邮箱"
          rules={[{ required: true, message: '邮箱为必填项' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          field="companyName"
          label="公司名称"
          rules={[{ required: true, message: '公司名称为必填项' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item field="location" label="公司地址">
          <Input />
        </Form.Item>
        <Form.List field="selected_products" initialValue={[]}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, field }) => (
                <Space
                  key={key}
                  style={{
                    display: 'flex',
                    border: '1px dashed rgba(0,0,0, 30%)',
                    padding: 12,
                    marginBottom: 24,
                  }}
                >
                  <MinusCircleOutlined
                    onClick={() => {
                      remove(key);
                    }}
                    style={{ color: 'red' }}
                  />
                  <div
                    style={{
                      width: 700,
                    }}
                  >
                    <Form.Item
                      field={[field, 'image_url'].join('.')}
                      label="选择商品"
                      required
                    >
                      <Select
                        options={generateOptions(selectedProducts)}
                        className="product-selector"
                        onChange={(value: string) => {
                          form.setFields({
                            // [['selected_products', , 'desc'].join('.')]: {
                            [`selected_products[${key}].desc`]: {
                              value: getDescByImageUrl(selectedProducts, value),
                            },
                            // [['selected_products', field, 'item_number'].join(
                            [`selected_products[${key}].item_number`]: {
                              value: getItemNumberByImageUrl(
                                selectedProducts,
                                value
                              ),
                            },
                            // [['selected_products', field, 'size'].join('.')]: {
                            [`selected_products[${key}].size`]: {
                              value: getSizeByImageUrl(selectedProducts, value),
                            },
                            // [['selected_products', field, 'title'].join('.')]: {
                            [`selected_products[${key}].title`]: {
                              value: getTitleByImageUrl(
                                selectedProducts,
                                value
                              ),
                            },
                          });
                        }}
                      ></Select>
                    </Form.Item>
                    <Form.Item
                      field={[field, 'title'].join('.')}
                      label="产品标题"
                      rules={[
                        {
                          required: true,
                          message: '产品标题为必填项',
                        },
                      ]}
                    >
                      <Input></Input>
                    </Form.Item>
                    <Form.Item
                      field={[field, 'secondary_title'].join('.')}
                      label="产品副标题"
                    >
                      <Input></Input>
                    </Form.Item>
                    <Form.Item
                      field={[field, 'item_number'].join('.')}
                      label="货号"
                      rules={[
                        {
                          required: true,
                          message: '货号为必填项',
                        },
                      ]}
                    >
                      <Input></Input>
                    </Form.Item>
                    <Form.Item field={[field, 'size'].join('.')} label="尺寸">
                      <Input></Input>
                    </Form.Item>
                    <Form.Item field={[field, 'price'].join('.')} label="价格">
                      <Input></Input>
                    </Form.Item>
                    <Form.Item
                      field={[field, 'desc'].join('.')}
                      label="产品描述"
                    >
                      <Input.TextArea></Input.TextArea>
                    </Form.Item>
                  </div>
                </Space>
              ))}
              <Button
                icon={<PlusOutlined />}
                onClick={() => add()}
                style={{ width: '100%' }}
              >
                添加商品
              </Button>
            </>
          )}
        </Form.List>
      </Form>
    </Modal>
  );
};

export default Index;
